import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useMobilePlatform from "../../hooks/useMobilePlatform";
import { isTargetBannerRoute } from "./mobileAppBannerUtils";

const APP_STORE_ID = "6553996625";

/**
 * Updates the static apple-itunes-app <meta> tag (in index.html) with
 * the current page URL as app-argument so the native app deep-links
 * to the right meeting.
 *
 * The tag must exist in index.html at initial parse for Safari to
 * recognise it — dynamically created tags are ignored.
 * This component only updates the content attribute on route changes.
 */
export default function AppBannerMeta() {
  const { isIOS, isRecorderBot } = useMobilePlatform();
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = document.querySelector('meta[name="apple-itunes-app"]');
    if (!meta) return;

    if (!isIOS || isRecorderBot || !isTargetBannerRoute(pathname)) {
      // Hide the banner on non-target pages by clearing content
      meta.setAttribute("content", "");
      return;
    }

    meta.setAttribute(
      "content",
      `app-id=${APP_STORE_ID}, app-argument=${window.location.href}`
    );
  }, [isIOS, isRecorderBot, pathname]);

  return null;
}
